import { styled, css } from 'styled-components';
import { Media } from '../../../../../theme/Media';
import { BORDER_RADIUS, DATA_ATTR_CAN_SCROLL_TOP, GROUP_SPACING, Z_INDEX_HEADROW } from '../../constants';
export const HeadRowWrapper = styled.div `
  display: grid;
  grid-template-columns: subgrid;
  grid-column: 1 / -1;
  overflow: clip;

  @media ${Media.smMin} {
    position: sticky;
    top: 0;
    z-index: ${Z_INDEX_HEADROW};
    background: ${({ theme }) => theme.colors.grey01_1};
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey10_1};

    [${DATA_ATTR_CAN_SCROLL_TOP}='true'] & {
      ${({ theme }) => theme.shadows.medium}
    }

    ${({ $inner }) => $inner &&
    css `
        &:last-child {
          border-bottom: none;
        }
      `}
  }

  @media ${Media.xsMax} {
    display: block;
    margin-bottom: ${GROUP_SPACING};
    border-radius: ${BORDER_RADIUS};

    ${({ theme, $inner }) => $inner
    ? css `
            border: 1px solid ${theme.colors.grey10_1};
          `
    : css `
            ${theme.shadows.small}
          `}
  }
`;
export const HeadRowInner = styled.div `
  display: grid;
  grid-template-columns: subgrid;
  grid-column: 1 / -1;
  background: ${({ theme }) => theme.colors.grey01_1};
  height: 100%;

  @media ${Media.xsMax} {
    background: ${({ theme }) => theme.colors.grey00_1};
    display: block;
  }
`;
